import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle, XCircle } from "lucide-react";
import { BRAND_COLORS } from "../lib/bookingStatus";

/**
 * Feb 2026 · Landing-Seite nach dem DOI-Klick aus der Bestaetigungsmail
 * (5 Sep 2026 · User-Directive). Der Backend-Endpoint
 * `GET /api/consent/marketing/confirm/{token}` redirect't hierher mit
 * `?status=success` oder `?status=invalid`. Nur ein statischer
 * Dank/Fehlermeldung-Screen — kein weiterer API-Call.
 */
export default function MarketingConfirmed() {
  const [params] = useSearchParams();
  const status = params.get("status");
  const ok = status === "success";

  return (
    <div
      className="min-h-screen flex items-center justify-center p-8"
      style={{ background: BRAND_COLORS.ivory }}
      data-testid="marketing-confirmed-page"
    >
      <div className="max-w-md w-full bg-white border border-navy/10 p-10 text-center">
        {ok ? (
          <>
            <CheckCircle
              className="w-14 h-14 mx-auto mb-6"
              strokeWidth={1.4}
              style={{ color: BRAND_COLORS.gold }}
              data-testid="marketing-confirmed-icon-success"
            />
            <div className="label-caps mb-3">Weissblom</div>
            <h1 className="font-display text-3xl md:text-4xl text-navy mb-4">
              Vielen Dank!
            </h1>
            <p className="text-[14px] text-navy-dark/80 leading-relaxed mb-8">
              Ihre Einwilligung ist bestätigt. Sie erhalten künftig
              gelegentliche E-Mails mit Angeboten und Neuigkeiten. Widerruf
              jederzeit über den Link am Ende jeder E-Mail möglich.
            </p>
          </>
        ) : (
          <>
            <XCircle
              className="w-14 h-14 mx-auto mb-6 text-navy-dark/40"
              strokeWidth={1.4}
              data-testid="marketing-confirmed-icon-invalid"
            />
            <div className="label-caps mb-3">Weissblom</div>
            <h1 className="font-display text-3xl md:text-4xl text-navy mb-4">
              Link nicht gültig
            </h1>
            <p className="text-[14px] text-navy-dark/80 leading-relaxed mb-8">
              Dieser Bestätigungslink ist entweder bereits verwendet oder
              nicht mehr gültig. Falls Sie sich zu Werbe-E-Mails anmelden
              möchten, tun Sie das bitte über Ihre Kontoeinstellungen.
            </p>
          </>
        )}
        <Link
          to="/login"
          data-testid="marketing-confirmed-login-link"
          className="inline-block bg-navy text-ivory px-6 py-3 text-[12px] tracking-[0.15em] uppercase hover:bg-navy-dark transition-colors"
          style={{ background: BRAND_COLORS.navy }}
        >
          Zur Anmeldung
        </Link>
      </div>
    </div>
  );
}
